import { libs, addLibs } from './base'
import './lazy-base'
import * as mui from '@sparky/material-ui'
import * as reactstrap from '@sparky/reactstrap'
import * as TokenManager from '@sparky/token-manager'
import versions from './versions'

Object.assign(versions, {
  react: libs.React.version,
  'react-dom': libs.ReactDOM.version,
})
if (libs.ReactIs.version) {
  versions['react-is'] = libs.ReactIs.version
}

export default addLibs({
  ...mui,
  reactstrap,
  TokenManager,
  versions,
})
